import React, { Suspense } from 'react'

import { Route, Switch } from 'react-router-dom'

import { LayoutSplashScreen } from '_metronic'

import { VENTASINGRESOGUIA_YAEMITIDAS } from 'constants/codigosTransacciones'

import MainPage from './main'

export default function VentaIngresoGuiasYaEmitidasPages() {
  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <Switch>
        <Route path={`/${VENTASINGRESOGUIA_YAEMITIDAS}`} component={MainPage} />
      </Switch>
    </Suspense>
  )
}
